require('dotenv').config()
const io = require("socket.io-client");

const socket = io("http://localhost:3030");//process.env.API_URL);

export default socket;
